import cookieHandler from '../handlers/cookieHandler'
import { Tokens } from '../types/tokenTypes'
import { Provider } from '../types/types'

export default (cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  return (tokens: Tokens, provider: Provider) => cookies.setTokens(tokens, provider)
}
